import React from 'react';
import styles from './Styles/EventOps.module.css';

/**
 * Per-channel reachability (SCRUM-356 Task 15) — renders the three
 * indicators the campaign-audience endpoint's `reach` map resolves
 * server-side: push (📱), sms (💬), email (✉).
 *
 * push: 'ok' | 'unknown' | 'dead' | 'none'
 * sms/email: 'ok' | 'optedOut' | 'none'
 */
const ICONS = { push: '📱', sms: '💬', email: '✉' };
const GLYPH = { ok: '✓', unknown: '?', dead: '✗', optedOut: '✗', none: '—' };
const CSS_CLASS = {
  ok: 'reachOk',
  unknown: 'reachUnknown',
  dead: 'reachDead',
  optedOut: 'reachDead',
  none: 'reachNone',
};

function titleFor(channel, state) {
  if (channel === 'push') {
    if (state === 'ok') return 'push: confirmed working';
    if (state === 'unknown') return 'push: device on file, not checked';
    if (state === 'dead') return 'push: device confirmed dead';
    return 'push: no device on file';
  }
  const label = channel === 'sms' ? 'SMS' : 'email';
  if (state === 'ok') return `${label}: works`;
  if (state === 'optedOut') return `${label}: opted out`;
  return `${label}: none on file`;
}

export function ReachLegend() {
  return (
    <div className={styles.reachLegend}>
      📱 push · 💬 SMS · ✉ email — ✓ works · ? not checked · ✗ won't (dead / opted out) · — none on file
    </div>
  );
}

export default function ReachIndicators({ reach }) {
  if (!reach) return null;
  return (
    <span className={styles.reachIndicators}>
      {['push', 'sms', 'email'].map((channel) => {
        const state = reach[channel] ?? 'none';
        return (
          <span
            key={channel}
            className={`${styles.reachBadge} ${styles[CSS_CLASS[state]] ?? ''}`}
            title={titleFor(channel, state)}
          >
            {ICONS[channel]}{GLYPH[state] ?? GLYPH.none}
          </span>
        );
      })}
    </span>
  );
}
